import { defineNuxtRouteMiddleware } from 'nuxt/app'
import { isPrivateRoute } from '~/shared/utils/helpers'
import { buildLoginUrl, getHosts } from '~/shared/utils/env'
import { getDefaultAccountRoute, hasRouteAccess } from '~/shared/utils/user-routes'
import { useUserStore } from '~/store/user'

export default defineNuxtRouteMiddleware(to => {
  if (!isPrivateRoute(to)) {
    return
  }

  const { user } = useUserStore()

  // неавторизованного отправляем в SSO с возвратом на запрошенную страницу
  if (!user) {
    const config = useRuntimeConfig()
    const hosts = getHosts({
      NUXT_PUBLIC_ENVIRONMENT_STAND: config.public.environmentStand,
    })
    const backUrl = useRequestURL().origin + to.fullPath

    return navigateTo(buildLoginUrl(hosts, backUrl), { external: true })
  }

  // корень ЛК разруливает redirect-to-default на странице /account
  if (/^\/account\/?$/.test(to.path)) {
    return
  }

  // страница вне доступов роли: уводим на стартовую страницу пользователя
  if (!hasRouteAccess(user, to.path)) {
    return navigateTo(getDefaultAccountRoute(user))
  }
})
